import Entity from 'lib/Entity';
import apiRequest from 'lib/apiRequest';
import User from 'entities/User';

type AccessTokenPayload = {
  user?: {
    device_address: string;
    password: string;
  };
  email_confirmation_token?: string;
  persist?: boolean;
  should_merge?: boolean;
  auth_token?: string;
};

type GoogleAuthPayload = {
  code: string;
  email_confirmation_token?: string;
};

export default class Session extends Entity {
  initialize() {
    // $FlowIssue
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.url = '/sessions';
  }

  isNew() {
    return false;
  }

  static createRequest(payload: AccessTokenPayload): Promise<User> {
    return apiRequest('/csrf_token', 'GET')
      .catch(() => {
        // If the CSRF prefetch fails, proceed anyway; the login endpoint will
        // return 403 if no valid token is present.
      })
      .then(() => apiRequest('/access_tokens/confirmed_login', 'POST', payload))
      .then(() => apiRequest('/user', 'GET'))
      .then((response) => User.fromJSON(response));
  }

  static create(
    deviceAddress: string,
    password: string,
    emailConfirmationToken: string | undefined | null = null,
    persist: boolean = false
  ): Promise<User> {
    const payload: AccessTokenPayload = {
      user: {
        device_address: deviceAddress,
        password,
      },
      persist,
    };

    if (emailConfirmationToken) {
      payload.email_confirmation_token = emailConfirmationToken;
      // If user is signing in with account uid + password AND
      // email_confirmation_token, it means they want to merge.
      payload.should_merge = true;
    }

    return this.createRequest(payload);
  }

  static createWithToken(token: string): Promise<User> {
    return this.createRequest({ auth_token: token });
  }

  static createWithGoogleAuthorizationCode(
    code: string,
    emailConfirmationToken: string | undefined | null = null
  ): Promise<User> {
    const payload: GoogleAuthPayload = { code };
    if (emailConfirmationToken) {
      payload.email_confirmation_token = emailConfirmationToken;
    }
    return apiRequest('/users/auth/google_plus/callback', 'POST', payload, false).then((response) =>
      User.fromJSON(response.user)
    );
  }

  static destroy() {
    return new Session().destroy();
  }
}
